// src/plugins/socket.js
import { io } from 'socket.io-client'

export default {
  install(app) {
    let socket = null
    const listeners = new Map() // track listeners so we can remove them

    function connect(url, userId) {
      if (socket && socket.connected) return socket

      socket = io(url, {
        transports: ['websocket'],
        reconnection: true,
        reconnectionAttempts: 5,
      })

      socket.on('connect', () => {
        // auto-join if userId present
        if (userId) {
          socket.emit('join-room', { userId })
        }
      })

      return socket
    }

    function joinRoom(roomId) {
      if (socket && socket.connected) {
        socket.emit('join-room', { userId: roomId })
      } else {
        console.warn('Socket not connected yet')
      }
    }

    function on(event, cb) {
      if (!socket) {
        console.warn('Socket not initialized yet. Call connect() first.')
        return
      }
      socket.on(event, cb)
      // store to remove later: we keep an array per event
      const arr = listeners.get(event) || []
      arr.push(cb)
      listeners.set(event, arr)
    }

    function off(event, cb) {
      if (!socket) return
      if (cb) {
        socket.off(event, cb)
        const arr = (listeners.get(event) || []).filter(fn => fn !== cb)
        listeners.set(event, arr)
      } else {
        socket.removeAllListeners(event)
        listeners.delete(event)
      }
    }

    function emit(event, data) {
      if (!socket) return
      socket.emit(event, data)
    }

    function disconnect() {
      if (socket) {
        socket.disconnect()
        socket = null
        listeners.clear()
      }
    }

    // expose helper object
    const socketHelper = {
      connect,
      joinRoom,
      on,
      off,
      emit,
      disconnect,
      getSocket: () => socket,
      isConnected: () => !!(socket && socket.connected),
    }

    // attach to Vue app instance and globalProperties
    app.config.globalProperties.$socket = socketHelper
    app.provide ? app.provide('socket', socketHelper) : null
  }
}
